(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["nyum-collection-v2"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = root => {
    if (!root || root.dataset.nyumMobileFilterReady) return;
    const panel = root.querySelector('[data-nyum-shop-filter-panel]');
    const trigger = root.querySelector('[data-nyum-shop-filter-open]');
    const backdrop = root.querySelector('.nyum-shop-filter-backdrop');
    const closers = root.querySelectorAll('[data-nyum-shop-filter-close]');
    if (!panel || !trigger || !backdrop) return;
    root.dataset.nyumMobileFilterReady = 'true';
    const media = window.matchMedia('(max-width: 749px)');
    const setOpen = (open, returnFocus = false) => {
      if (open && !media.matches) return;
      panel.classList.toggle('is-open', open);
      backdrop.classList.toggle('is-open', open);
      trigger.setAttribute('aria-expanded', String(open));
      document.documentElement.classList.toggle('nyum-shop-filter-lock', open);
      if (media.matches) {
        panel.inert = !open;
        panel.setAttribute('aria-hidden', String(!open));
        panel.setAttribute('role', 'dialog');
        panel.setAttribute('aria-modal', 'true');
      }
      if (open) {
        panel.querySelector('[data-nyum-shop-filter-close]')?.focus({ preventScroll: true });
      } else if (returnFocus) {
        trigger.focus({ preventScroll: true });
      }
    };
    const syncMode = () => {
      setOpen(false);
      if (media.matches) {
        panel.inert = true;
        panel.setAttribute('aria-hidden', 'true');
        panel.setAttribute('role', 'dialog');
        panel.setAttribute('aria-modal', 'true');
      } else {
        panel.inert = false;
        panel.removeAttribute('aria-hidden');
        panel.removeAttribute('role');
        panel.removeAttribute('aria-modal');
      }
    };
    trigger.addEventListener('click', () => setOpen(true));
    closers.forEach(button => button.addEventListener('click', () => setOpen(false, true)));
    panel.querySelectorAll('[data-nyum-shop-filter]').forEach(button => button.addEventListener('click', () => setOpen(false, true)));
    document.addEventListener('keydown', event => {
      if (event.key === 'Escape' && panel.classList.contains('is-open')) setOpen(false, true);
    });
    media.addEventListener('change', syncMode);
    syncMode();
  };
  const boot = () => document.querySelectorAll('[data-nyum-shop]').forEach(init);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nyum-weekend-campaign"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = () => {
    const root = document.getElementById('nyum-weekend-campaign');
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';
    const deadline = Date.parse(root.dataset.deadline);
    const strings = JSON.parse(root.querySelector('[data-nf-strings]').textContent);
    const format = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency', currency:root.dataset.currency || 'USD'});
    const money = cents => format.format(cents / 100);
    const products = [...root.querySelectorAll('[data-nf-product]')];
    const submit = root.querySelector('[data-nf-add]');
    const status = root.querySelector('[data-nf-status]');
    let busy = false;
    let interval;
    const tick = () => {
      const remaining = Math.max(0, Math.floor((deadline - Date.now()) / 1000));
      if (!root.isConnected || remaining <= 0) {
        clearInterval(interval);
        if (root.isConnected) root.remove();
        return;
      }
      root.querySelector('[data-nf-hours]').textContent = String(Math.floor(remaining / 3600)).padStart(2,'0');
      root.querySelector('[data-nf-minutes]').textContent = String(Math.floor(remaining % 3600 / 60)).padStart(2,'0');
      root.querySelector('[data-nf-seconds]').textContent = String(remaining % 60).padStart(2,'0');
    };
    const selection = () => products.map(card => ({card, id:Number(card.dataset.variant), quantity:Number(card.querySelector('[data-nf-quantity]').value) || 0, price:Number(card.dataset.price)})).filter(item => item.quantity > 0);
    const update = () => {
      let original = 0, total = 0, count = 0;
      products.forEach(card => {
        const input = card.querySelector('[data-nf-quantity]');
        const quantity = input.disabled ? 0 : Math.max(0, Math.min(12, Math.floor(Number(input.value) || 0)));
        input.value = quantity;
        input.readOnly = busy;
        const pack = card.querySelector('[data-nf-pack]');
        if (pack) pack.disabled = busy;
        card.classList.toggle('is-selected', quantity > 0);
        card.querySelector('[data-nf-minus]').disabled = quantity === 0 || busy;
        card.querySelector('[data-nf-plus]').disabled = input.disabled || quantity >= 12 || busy;
        const line = Number(card.dataset.price) * quantity;
        original += line;
        total += line - Math.floor(line / 10);
        count += quantity * Number(card.dataset.bottles || 1);
      });
      root.querySelector('[data-nf-count]').textContent = count ? (count === 1 ? strings.one : strings.many.replace('[count]',count)) : strings.choose;
      root.querySelector('[data-nf-original]').textContent = count ? money(original) : '';
      root.querySelector('[data-nf-total]').textContent = money(total);
      root.querySelector('[data-nf-saving]').textContent = count ? strings.saving.replace('[amount]',money(original-total)) : '';
      submit.disabled = count === 0 || busy;
    };
    root.querySelector('.nf-code-text').addEventListener('click', event => event.target.select());
    root.querySelector('[data-nf-copy]').addEventListener('click', async () => {
      const label = root.querySelector('[data-nf-copy-label]');
      try {
        if (!navigator.clipboard?.writeText) throw new Error('Clipboard unavailable');
        await navigator.clipboard.writeText('STOCKUP10');
        label.textContent = strings.copied;
        setTimeout(() => { if (label.isConnected) label.textContent = strings.copy; }, 3000);
      } catch {
        root.querySelector('.nf-code-text').select();
        label.textContent = strings.copy_fallback;
      }
    });
    products.forEach(card => {
      const input = card.querySelector('[data-nf-quantity]');
      const pack = card.querySelector('[data-nf-pack]');
      pack?.addEventListener('change', () => {
        const option = pack.selectedOptions[0];
        card.dataset.variant = option.value;
        card.dataset.price = option.dataset.price;
        card.dataset.bottles = option.dataset.bottles;
        input.disabled = option.disabled;
        const price = Number(option.dataset.price);
        const discounted = price - Math.floor(price / 10);
        card.querySelector('[data-nf-price]').textContent = money(discounted);
        card.querySelector('[data-nf-price-original]').textContent = money(price);
        const perBottle = card.querySelector('[data-nf-unit-price]');
        perBottle.hidden = Number(option.dataset.bottles) < 2;
        perBottle.textContent = strings.per_bottle.replace('[amount]', money(discounted / Number(option.dataset.bottles)));
        card.querySelectorAll('[data-nf-product-link]').forEach(link => {
          const url = new URL(link.href);
          url.searchParams.set('variant', option.value);
          link.href = url.toString();
        });
        update();
      });
      card.querySelector('[data-nf-minus]').addEventListener('click', () => { input.value = Number(input.value)-1; update(); });
      card.querySelector('[data-nf-plus]').addEventListener('click', () => { input.value = Number(input.value)+1; update(); });
      input.addEventListener('change', update);
    });
    root.querySelector('[data-nf-form]').addEventListener('submit', async event => {
      event.preventDefault();
      if (busy || !selection().length) return;
      if (Date.now() >= deadline) { status.textContent = strings.expired; tick(); return; }
      busy = true; update(); status.textContent = '';
      root.querySelector('[data-nf-add-label]').textContent = strings.adding;
      let added = false;
      try {
        const items = selection().map(({id,quantity}) => ({id,quantity}));
        const response = await fetch(root.dataset.cartAdd, {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || strings.error);
        added = true;
        const discount = await fetch(root.dataset.cartUpdate, {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({discount:'STOCKUP10'})});
        if (!discount.ok) throw new Error(strings.discount_error);
        document.dispatchEvent(new CustomEvent('nyum:flash-cart-added', {detail:{items,code:'STOCKUP10'}}));
        window.location.assign(root.dataset.cartUrl);
      } catch (error) {
        if (added) {
          status.textContent = strings.discount_error;
          window.location.assign(root.dataset.cartUrl);
          return;
        }
        status.textContent = error.message || strings.error;
        busy = false; update();
        root.querySelector('[data-nf-add-label]').textContent = strings.add;
      }
    });
    interval = setInterval(tick, 1000); tick(); update();
    document.addEventListener('visibilitychange', tick);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();

  } catch(e) { console.error(e); }
})();
})();
